(() => {
  const DESKTOP_MQ = window.matchMedia('(min-width: 992px)');

  function initPdpScrollAccordions() {
    const media = document.querySelector('[id^="ProductMedia-"]');
    const description = document.querySelector('[data-pdp-accordion="description"]');
    const manufacture = document.querySelector('[data-pdp-accordion="manufacture"]');

    if (!media) return;

    // Start folded (manual unfold still works)
    if (description) description.removeAttribute('open');
    if (manufacture) manufacture.removeAttribute('open');

    let descOpenedByScroll = false;
    let mfgOpenedByScroll = false;

    const openDetails = (el) => {
      if (!el || el.open) return;
      el.setAttribute('open', '');
    };

    const onScroll = () => {
      if (!DESKTOP_MQ.matches) return;

      const mediaRect = media.getBoundingClientRect();
      const mediaBottom = mediaRect.bottom;
      const viewportH = window.innerHeight || document.documentElement.clientHeight;

      // Near end of image column → open Description
      if (!descOpenedByScroll && mediaBottom < viewportH * 0.65) {
        openDetails(description);
        descOpenedByScroll = true;
      }

      // After images mostly gone → open Manufactured by
      if (descOpenedByScroll && !mfgOpenedByScroll && mediaBottom < viewportH * 0.28) {
        openDetails(manufacture);
        mfgOpenedByScroll = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpScrollAccordions);
  } else {
    initPdpScrollAccordions();
  }
})();
